import * as Sentry from '@sentry/react';

const isDev = import.meta.env.DEV;

function toMessage(args: unknown[]): string {
  return args
    .map((a) => (a instanceof Error ? a.message : typeof a === 'string' ? a : JSON.stringify(a)))
    .join(' ');
}

export const log = {
  error(...args: unknown[]): void {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
    const err = args.find((a) => a instanceof Error) as Error | undefined;
    if (err) {
      Sentry.captureException(err, { extra: { args: args.filter((a) => a !== err) } });
    } else {
      Sentry.captureMessage(toMessage(args), 'error');
    }
  },

  warn(...args: unknown[]): void {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },

  debug(...args: unknown[]): void {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
};
